<div class="content unselectable">
    <div class="shortcuts">
        @for (item of homeContentStore.shortcuts(); track item.id) {
        <a class="shortcut" target="_blank"
            [href]="item.url">
            <img [src]="item.imageSrc" [alt]="item.title">
        </a>
        }
    </div>
</div>
